import { Cell } from 'baseui/layout-grid';
import { Input, StyledInput, SIZE } from 'baseui/input';
import { Select } from 'baseui/select';
import { Tag } from 'baseui/tag';
import { RadioGroup, Radio, ALIGN } from 'baseui/radio';
import capitalize from 'lodash/capitalize';
import get from 'lodash/get';
import uniq from 'lodash/uniq';
import { styled } from 'baseui';
import * as React from 'react';
import { EditModeInput } from '../common/Input';
import { NumberSubType } from '../../reducers';
import { SelectSubType } from '../../reducers';
import { type QuestionType, questionTypes, TERRABLOB_METADATA_KEY } from '../../reducers';
import { getTerrablobPath } from '../../utils/question';
import { getAllValidationFromTags } from '../../reducers/selectors';
type PropsT = {
  showTag: boolean;
  editMode: boolean;
  question: QuestionType;
  updateQuestion: Function;
};
type StateT = {
  tagInputValue: string;
};
const ValueWrapper = styled('div', {
  flex: '1 1 0%',
  flexWrap: 'wrap',
  display: 'flex',
  alignItems: 'center'
});
type InputReplacementT = {
  tags: string[];
  removeTag: (a: string) => void;
};
const InputReplacement = ({
  tags,
  removeTag,
  ...rest
}: InputReplacementT) => {
  return <ValueWrapper>
      {tags.map((tag, index) => <Tag kind="positive" onActionClick={() => removeTag(tag)} key={index}>
          {tag}
        </Tag>)}
      {/* @ts-expect-error todo(ts-migration) TS2739 Type '{}' is missing the following properties from type 'SharedProps': $adjoined, $size */}
      <StyledInput {...rest} />
    </ValueWrapper>;
};
const QuestionTypeOptions = [{
  label: 'Select',
  id: questionTypes.select
}, {
  label: 'Input',
  id: questionTypes.input
}, {
  label: 'Rich Text Editor',
  id: questionTypes.richText
}, {
  label: 'Number',
  id: questionTypes.number
}, {
  label: 'File Upload',
  id: questionTypes.file
}];
export default class QuestionMeta extends React.Component<PropsT, StateT> {
  overrideContainer: React.ComponentType<any>;
  overrideInput: React.ComponentType<any>;
  state = {
    tagInputValue: ''
  };
  removeTag = (tag: any) => {
    const {
      question,
      updateQuestion
    } = this.props;
    const tags = get(question, 'tags') || [];
    updateQuestion({
      ...question,
      tags: tags.filter(t => t !== tag)
    });
  };
  getLimitValue(subType: SelectSubType) {
    switch (subType) {
      case SelectSubType.drag_and_rank:
        return [];
      case SelectSubType.checkbox:
        return [{
          id: -1,
          label: 'Any'
        }];
      case SelectSubType.radio:
        return [{
          id: 1,
          label: 1
        }];
    }
  }
  render(): React.ReactNode {
    const {
      editMode,
      showTag,
      question,
      updateQuestion
    } = this.props;
    const {
      tagInputValue
    } = this.state;
    const limit = get(question, 'limit');
    const type = get(question, 'type');
    const tags = get(question, 'tags') || [];
    const subType = (tags.find(tag => tag === SelectSubType.drag_and_rank || tag === NumberSubType.rating_slider) as SelectSubType | NumberSubType | undefined);
    const selectedType = QuestionTypeOptions.filter(option => option.id === type) || [];
    const isFileUploadQues = selectedType[0]?.id === questionTypes.file;
    const terrablobPath = getTerrablobPath(question) || '';
    return <React.Fragment>
        {showTag && <Cell span={[4, 8, 12]}>
            <Input size={SIZE.compact} value={tagInputValue} placeholder={editMode ? "press 'Enter' to add a tag" : ''} onKeyPress={e => {
          if (e.key === 'Enter') {
            if (!this.state.tagInputValue) {
              return;
            }

            // adding a tag
            const nextTags = get(this.props.question, 'tags');
            nextTags.push(this.state.tagInputValue);
            this.props.updateQuestion({
              ...question,
              tags: uniq(nextTags)
            });

            // update input
            this.setState({
              tagInputValue: ''
            });
          }
        }} onChange={e => {
          const value = e.target.value;
          this.setState({
            tagInputValue: value
          });
        }} overrides={{
          Root: editMode ? {} : {
            style: {
              outline: `0 solid`
            }
          },
          InputContainer: editMode ? {} : {
            style: {
              border: 0,
              background: 'transparent'
            }
          },
          Input: {
            style: {
              width: 'auto',
              flexGrow: 1
            },
            component: InputReplacement,
            props: {
              tags,
              removeTag: this.removeTag
            }
          }
        }} />
          </Cell>}
        <Cell span={[4, 5, 8]}>
          <EditModeInput value={selectedType[0]?.label} editMode={editMode}>
            <Select valueKey={'id'} placeholder={'Multi choice or Text'} size={SIZE.compact} value={selectedType} onChange={params => {
            const nextType = get(params, 'option.id');
            const validationTags = getAllValidationFromTags(question.tags);
            const nextTags = tags.filter(tag => !validationTags.find(validationType => tag.includes(validationType.type)));
            const nextQuestion = {
              ...question,
              type: nextType,
              validations: [],
              tags: nextTags
            };
            if (nextType === questionTypes.select) {
              nextQuestion.limit = 1;
            } else if (nextType === questionTypes.file) {
              nextQuestion.answers = [{
                answer: 'file',
                note: 'none',
                metadata: {
                  [TERRABLOB_METADATA_KEY]: ''
                }
              }];
            } else if (isFileUploadQues) {
              nextQuestion.answers = [];
            }
            updateQuestion(nextQuestion);
          }} options={QuestionTypeOptions} />
          </EditModeInput>
        </Cell>
        {type === questionTypes.select && <>
            <Cell span={[4, 3, 4]}>
              {/* @ts-expect-error todo(ts-migration) TS2322 Type 'number' is not assignable to type 'string'. */}
              <EditModeInput value={limit} editMode={editMode}>
                <Select size={SIZE.compact} placeholder={'Select up to...'} value={subType ? this.getLimitValue((subType as SelectSubType)) : limit ?
            // @ts-expect-error todo(ts-migration) TS2345 Argument of type 'number' is not assignable to parameter of type 'string'.
            [{
              id: limit,
              label: capitalize(limit)
            }] : []} onChange={option => {
              updateQuestion({
                ...question,
                limit: get(option, 'option.id')
              });
            }} options={[{
              id: -1,
              label: 'Any'
            }, {
              id: 1,
              label: '1'
            }, {
              id: 2,
              label: '2'
            }, {
              id: 3,
              label: '3'
            }, {
              id: 4,
              label: '4'
            }, {
              id: 5,
              label: '5'
            }]} disabled={subType ? true : false} />
              </EditModeInput>
            </Cell>
            <Cell span={[4, 5, 9]}>
              <RadioGroup align={ALIGN.horizontal} onChange={e => {
            if (e.target.value !== 'select') {
              const nextTags = get(this.props.question, 'tags');
              nextTags.push(SelectSubType.drag_and_rank);
              updateQuestion({
                ...question,
                limit: this.getLimitValue((e.target.value as SelectSubType))[0]?.id,
                tags: uniq(nextTags)
              });
            } else {
              this.removeTag(SelectSubType.drag_and_rank);
            }
          }} value={subType ?? 'select'} name="select-subtype">
                <Radio value="select">Select</Radio>
                <Radio value={SelectSubType.drag_and_rank}>Drag and Rank</Radio>
              </RadioGroup>
            </Cell>
          </>}
        {type === questionTypes.number && <Cell span={[4, 5, 9]}>
            <RadioGroup align={ALIGN.horizontal} onChange={e => {
          if (e.target.value !== 'number') {
            const nextTags = get(this.props.question, 'tags');
            nextTags.push(NumberSubType.rating_slider);
            updateQuestion({
              ...question,
              tags: uniq(nextTags)
            });
          } else {
            this.removeTag(NumberSubType.rating_slider);
          }
        }} value={subType ?? 'number'} name="number-subtype">
              <Radio value="number">Number</Radio>
              <Radio value={NumberSubType.rating_slider}>Rating Slider</Radio>
            </RadioGroup>
          </Cell>}
        {isFileUploadQues && <Cell span={[4, 5, 8]}>
            <EditModeInput value={terrablobPath} editMode={editMode}>
              <Input size={SIZE.compact} value={terrablobPath} placeholder="Input Terrablob path to store file e.g. /prod/gss/answers" required onChange={e => updateQuestion({
            ...question,
            answers: [{
              ...(question.answers[0] ? question.answers[0] : {}),
              metadata: {
                [TERRABLOB_METADATA_KEY]: e.target.value
              }
            }]
          })} />
            </EditModeInput>
          </Cell>}
      </React.Fragment>;
  }
}